import React from 'react';
import { PopoverArrow, PopoverArrowProps } from '../PopoverArrow';

export interface PopoverContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  arrowRef?: PopoverArrowProps['ref'];
  arrowColor?: PopoverArrowProps['fill'];
  arrowSize?: PopoverArrowProps['width'];
  context: PopoverArrowProps['context'];
  hideArrow?: boolean;
}
/**
 * PopoverContent Component
 *
 * It contains the content of the popover and the arrow element that are being used
 * in the `PopoverBase` and `PopoverWrapper` components
 *
 * @param children - The content of the popover
 * @param arrowRef - The reference of the arrow used to position the popover arrow
 * @param arrowColor - The color of the popover arrow element. **@deprecated** Use design token --tooltip-arrow. Arrow color is token-driven for tooltips.
 * @param arrowSize - The size of the popover arrow element
 * @param context - The object that contains the information of the popover. https://floating-ui.com/docs/usefloating#context
 * @param hideArrow - Boolean to hide the popover arrow element
 */
export const PopoverContent = React.forwardRef<HTMLDivElement, PopoverContentProps>(
  ({ children, context, arrowRef, arrowColor, arrowSize, hideArrow, ...rest }, ref) => {
    return (
      <div ref={ref} {...rest}>
        {!hideArrow && context && (
          <PopoverArrow ref={arrowRef} context={context} width={arrowSize} fill={arrowColor} />
        )}
        {children}
      </div>
    );
  },
);
